import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { ApiResponseValue, ApiResponse } from '@/types/validateContainerBlType';

export type Validated = {
  oidVisita: number;
};

export const validateContainerExport = async (
  query: Validated
): Promise<ApiResponseValue> => {
  try {
    const res = await apiClient.post<ApiResponse>(
      Endpoints.ValidateContainerExport,
      {
        oidVisita: query?.oidVisita,
      }
    );

    const { value } = res?.data || {};

    const response: ApiResponseValue =
      typeof value === 'string' && value
        ? {
            ok: false,
            mensaje: value,
            okSpecified: false,
          }
        : value;

    return response;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
